
interface Statement {
    action: string[];
    effect: "Allow" | "Deny";
    resource: string[];
}

interface PolicyInternal {
    name: string;
    description: string;
    statement: Statement[];
}

type Policies = Record<string, PolicyInternal>;

export const policies: Policies = {
    fullLinkReadAccess: {
        name: '${userId}$FullLinkReadAccess',
        description: 'Provides full read only access to Link services.',
        statement: [
            {
                action: [
                    'link:GetTeamLink',
                    'link:ListTeamLinks'
                ],
                effect: 'Allow',
                resource: ['srn:smash:link:$account:*:team/*']
            },
            {
                action: [
                    'link:GetTarget',
                ],
                effect: 'Allow',
                resource: ['srn:smash:link::*:target/*']
            }
        ]
    },
    fullBasicAccess: {
        name: '${userId}$FullBasicAccess',
        description: 'Provides full basic access',
        statement: [
            {
                action: [
                    'transfer:CreateTransfer',
                    'transfer:GetTransfer',
                    'transfer:ListTransfers',
                    'transfer:DeleteTransfer',
                    'transfer:CreateTeamTransfer',
                    'transfer:ListUserTransfers',
                    'transfer:GetUserTransfer',
                    'transfer:ListUserTransferFiles',
                    'transfer:ListTeamUserTransfers',
                    'transfer:ListUserTransferEvents',
                    'transfer:DeleteUserTransfer',
                    'transfer:LockTransfer',
                    'transfer:CreateTransferFile',
                    'transfer:DeleteTransferFile',
                    'transfer:UpdateTransferFile',
                    'transfer:CreateTransferFilePart',
                    'transfer:CreateTransferFileParts',
                    'transfer:UpdateTransferFilePart',
                    'transfer:UpdateTransferFileParts',
                    'transfer:GetTransferPreview',
                    'transfer:GetTransferFilePreview',
                    'transfer:ListTransferFilesPreview',
                    'transfer:CreateTransferSignedUrls',
                    'transfer:GetUsage'
                ],
                effect: 'Allow',
                resource: [
                    'srn:smash:transfer:$account:*:team/*/transfer/*',
                    'srn:smash:transfer:$account:*:team/*/transfer',
                    'srn:smash:transfer:$account:*:user/*/transfer/*',
                    'srn:smash:transfer:$account:*:user/*/transfer',
                    'srn:smash:transfer:$account:*:transfer/*',
                    'srn:smash:transfer:$account:*:transfer',
                    'srn:smash:transfer::*:transfer/*',
                    'srn:smash:transfer:$account:*:usage',
                ]
            },
        ]
    },
    teamLinkReadAccess: {
        name: '${teamId}$LinkReadAccess',
        description: 'Provides read only access to Link services.',
        statement: [
            {
                action: [
                    'link:GetTeamLink',
                    'link:ListTeamLinks'
                ],
                effect: 'Allow',
                resource: ['srn:smash:link:$account:*:team/${teamId}/*']
            },
            {
                action: [
                    'link:GetTarget',
                ],
                effect: 'Allow',
                resource: ['srn:smash:link::*:target/*']
            }
        ]
    },
    teamBasicAccess: {
        name: '${teamId}$BasicAccess',
        description: 'Provides basic access',
        statement: [
            {
                action: [
                    'transfer:CreateTransfer',
                    'transfer:GetTransfer',
                    'transfer:ListTransfers',
                    'transfer:DeleteTransfer',
                    'transfer:CreateTeamTransfer',
                    'transfer:ListUserTransfers',
                    'transfer:GetUserTransfer',
                    'transfer:ListUserTransferFiles',
                    'transfer:ListTeamUserTransfers',
                    'transfer:ListUserTransferEvents',
                    'transfer:DeleteUserTransfer',
                    'transfer:LockTransfer',
                    'transfer:CreateTransferFile',
                    'transfer:DeleteTransferFile',
                    'transfer:UpdateTransferFile',
                    'transfer:CreateTransferFilePart',
                    'transfer:CreateTransferFileParts',
                    'transfer:UpdateTransferFilePart',
                    'transfer:UpdateTransferFileParts',
                    'transfer:GetTransferPreview',
                    'transfer:GetTransferFilePreview',
                    'transfer:ListTransferFilesPreview',
                    'transfer:CreateTransferSignedUrls',
                    'transfer:GetUsage'
                ],
                effect: 'Allow',
                resource: [
                    'srn:smash:transfer:$account:*:team/${teamId}/user/*/transfer/*',
                    'srn:smash:transfer:$account:*:team/${teamId}/user/*/transfer',
                    'srn:smash:transfer:$account:*:team/${teamId}/transfer/*',
                    'srn:smash:transfer:$account:*:team/${teamId}/transfer',
                    'srn:smash:transfer:$account:*:user/*/transfer/*',
                    'srn:smash:transfer:$account:*:user/*/transfer',
                    'srn:smash:transfer:$account:*:transfer/*',
                    'srn:smash:transfer:$account:*:transfer',
                    'srn:smash:transfer::*:transfer/*',
                    'srn:smash:transfer:$account:*:usage',
                ]
            }
        ]
    }
}

